class LocationDrawers extends HTMLElement {
  constructor() {
    super()

    this.location = document.querySelector('.location-wrapper')
    this.accordion = this.querySelector('.prd-accordion')

    this.initialiseLocationDrawers()
  }

  initialiseLocationDrawers() {
    const locationWidthWrapper = document.querySelector('.page-width');
    if (locationWidthWrapper) {

      // hide location app
      locationWidthWrapper.style.display = 'none';

      // move location app to drawer and show drawer
      setTimeout(() => {
        this.accordion.classList.remove('prd-accordion--hidden');
        this.location.appendChild(locationWidthWrapper);

        const note = document.querySelector('.iia-id-65693515965 .iia-note')
        const item = document.querySelector('.iia-id-65693515965')
        if (note != null && item != null) {
          item.insertAdjacentElement('beforeend', note);
          locationWidthWrapper.style.display = 'block';
        } else {
          const drawer = document.querySelector('.prd-accordion--location')
          drawer.style.display = 'none';
        }
      })
    } 
  }
}

customElements.define('location-drawers', LocationDrawers)
